var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ma-modal",
    {
      ref: "calculateSurfaceModal",
      attrs: { type: "full" },
      on: {
        "modal:close": function ($event) {
          return _vm.handleModal(false)
        },
      },
    },
    [
      _c("template", { slot: "modalContent" }, [
        _c("div", { staticClass: "modal__main view" }, [
          _c("div", { staticClass: "view_content" }, [
            _c(
              "p",
              { staticClass: "text-large gray mg mg--b-14 center bold" },
              [
                _vm._v(
                  _vm._s(_vm.$t("multidamageList.calculateSurfaceModal.title"))
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "grid mg mg--b-6" },
              [
                _c("ma-input", {
                  attrs: {
                    type: "text",
                    name: "surfaceWidth",
                    col: "4",
                    literal: _vm.$t(
                      "multidamageList.calculateSurfaceModal.input1"
                    ),
                    inputError: _vm.$v.inputWidthSurfaceValue.$error,
                    inputTextError: _vm.$t(
                      "multidamageList.calculateSurfaceModal.inputErrorText"
                    ),
                  },
                  model: {
                    value: _vm.$v.inputWidthSurfaceValue.$model,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.$v.inputWidthSurfaceValue,
                        "$model",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "$v.inputWidthSurfaceValue.$model",
                  },
                }),
                _c("ma-input", {
                  attrs: {
                    type: "text",
                    name: "surfaceLength",
                    col: "4",
                    literal: _vm.$t(
                      "multidamageList.calculateSurfaceModal.input2"
                    ),
                    inputError: _vm.$v.inputLengthSurfaceValue.$error,
                    inputTextError: _vm.$t(
                      "multidamageList.calculateSurfaceModal.inputErrorText"
                    ),
                  },
                  model: {
                    value: _vm.$v.inputLengthSurfaceValue.$model,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.$v.inputLengthSurfaceValue,
                        "$model",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "$v.inputLengthSurfaceValue.$model",
                  },
                }),
              ],
              1
            ),
            _c("p", { staticClass: "text-large gray mg mg--b-6 center" }, [
              _vm._v(
                _vm._s(_vm.$t("multidamageList.calculateSurfaceModal.text"))
              ),
            ]),
            _c("div", { staticClass: "grid grid--jc-middle mg mg--b-10" }, [
              _c(
                "svg",
                {
                  attrs: {
                    fill: "none",
                    width: "200",
                    height: "176",
                    viewBox: "0 0 200 176",
                    preserveAspectRatio: "xMinYMid meet",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M45 42.5v115h110v-115H45Zm92.4 5.227h12.362v17.564l-1.488 1.485-14.981-14.95 4.191-4.182-.084.083Zm-72.265 72.136 13.41-13.382 7.5 7.465 7.48 7.485-19.276 19.237-6.432 6.377-14.96-14.929 12.278-12.253Zm-13.41 11.166-1.11 1.108-.377.376v-27.558l6.286 6.273 7.48 7.485-12.278 12.316Zm56.321-21.891 14.981 14.908-25.709 25.676-14.981-14.929 25.709-25.655Zm-13.41 11.165-7.48-7.486-7.5-7.464 12.298-12.274.566-.544.545-.564 12.299-12.274 7.48 7.486 7.501 7.464-25.709 25.656Zm-2.682-29.44-14.98-14.908L89.271 63.68l13.41-13.36 7.48 7.464 7.501 7.464-12.299 12.274-1.111 1.108-12.299 12.232Zm22-4.789-7.48-7.485 13.41-13.382 12.299-12.253 14.96 14.93-25.688 25.655-7.501-7.465Zm34.32-17.082 1.488-1.485v27.517l-13.787-13.758 12.299-12.274Zm-43.036-21.265h29.941l-2.996 2.99-1.111 1.108L118.773 64.1l-7.501-7.465-7.48-7.464 1.446-1.443Zm-2.242 0-.314.314-1.111 1.129-12.299 12.252-7.48-7.464-6.285-6.273 27.489.042Zm-52.758 0h20.596l-11.063 11.02-9.533-9.514v-1.506Zm0 3.722 8.381 8.364-8.381 8.364V51.449Zm0 19.048 22.817-22.77.126-.125.147.125 7.354 7.318 7.48 7.465-12.257 12.295-1.11 1.108-12.3 12.273-7.543-7.464-4.714-4.767v-5.458Zm0 7.715 3.625 3.617 7.48 7.465-11.105 11.082V78.212Zm0 24.402 12.215-12.19 1.11-1.109 12.342-12.294 14.98 14.95-12.298 12.273-1.11 1.109-12.3 12.273-7.48-7.485-7.417-7.402-.042-.125Zm0 49.659v-17.564l1.488-1.484 14.98 14.929-4.19 4.182-12.278-.063Zm44.524 0h-29.94l2.995-2.99.734-.732.377-.397 5.888-5.855 6.41-6.398 14.982 14.929-1.446 1.443Zm2.221-.001 13.745-13.59 7.48 7.464 6.285 6.273-27.51-.147Zm52.779.001h-20.596l11.063-11.019 9.533 9.513v1.506Zm0-3.722-8.381-8.364 8.381-8.363v16.727Zm0-19.048-9.534 9.514-.565.564-.545.544-12.174 12.148-.125.125-.147-.125-7.354-7.318-7.48-7.465 25.708-25.676 7.501 7.464 4.715 4.768v5.457Zm0-7.716-3.625-3.617-7.375-7.465 11.105-11.103-.105 22.185Zm-.001-24.4-25.666 25.592-14.981-14.95 25.75-25.655 14.897 14.887v.125Z",
                      fill: "#E4EEF6",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "m44.66 18.214-1.097-2.52c-.692-1.59-2.447-2.348-4.014-1.735l-2.43.95a3.422 3.422 0 0 1-2.84-.155 2.406 2.406 0 0 0-2.43.114 2.632 2.632 0 0 0-1.183 2.215c0 .837.385 1.623 1.035 2.113.651.489 1.488.622 2.249.358l.917-.32a8.077 8.077 0 0 1 6.408.475l1.25.653c.597.31 1.316.196 1.796-.286.48-.483.616-1.228.34-1.862ZM45.667 19.827c0 .96.746 1.74 1.666 1.74.92 0 1.667-.78 1.667-1.74s-.746-1.739-1.667-1.739c-.92 0-1.666.779-1.666 1.74ZM44.833 16.783c0 .72.56 1.305 1.25 1.305s1.25-.584 1.25-1.305c0-.72-.56-1.304-1.25-1.304s-1.25.584-1.25 1.304ZM44 14.61c0 .48.372.869.833.869.46 0 .833-.39.833-.87s-.373-.87-.833-.87c-.46 0-.834.39-.834.87ZM42.332 12.87c0 .48.373.87.834.87.46 0 .833-.39.833-.87s-.373-.87-.834-.87c-.46 0-.833.39-.833.87ZM36.898 28.306l1.098-2.52c.276-.634.139-1.379-.34-1.862a1.523 1.523 0 0 0-1.795-.286l-1.25.653a8.077 8.077 0 0 1-6.408.475l-.918-.319a2.41 2.41 0 0 0-2.248.358A2.638 2.638 0 0 0 24 26.917c0 .902.448 1.74 1.184 2.215a2.406 2.406 0 0 0 2.428.114 3.426 3.426 0 0 1 2.842-.155l2.429.95c1.568.613 3.323-.145 4.015-1.735ZM38.998 24.174c0 .96.747 1.74 1.667 1.74s1.667-.78 1.667-1.74-.746-1.739-1.667-1.739c-.92 0-1.667.779-1.667 1.74ZM38.165 27.217c0 .72.56 1.305 1.25 1.305s1.25-.584 1.25-1.305c0-.72-.56-1.304-1.25-1.304s-1.25.584-1.25 1.304ZM37.333 29.391c0 .48.373.87.833.87.46 0 .834-.39.834-.87s-.374-.87-.834-.87c-.46 0-.833.39-.833.87ZM35.667 31.13c0 .48.373.87.833.87.46 0 .834-.39.834-.87s-.373-.87-.834-.87c-.46 0-.833.39-.833.87Z",
                      fill: "#005BA5",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      stroke: "#005BA5",
                      "stroke-dasharray": "2 4",
                      d: "M75 22h50M25 107.5v-50",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M21.25 115.625a.62.62 0 0 1 .4.145l3.357 2.797 3.351-2.696a.624.624 0 1 1 .784.973l-3.75 3.018a.624.624 0 0 1-.792-.007l-3.75-3.125a.625.625 0 0 1 .4-1.105ZM133.75 26.875a.625.625 0 0 1-.48-1.025l2.797-3.357-2.697-3.351a.626.626 0 0 1 .975-.784l3.017 3.75a.625.625 0 0 1-.007.792l-3.125 3.75a.623.623 0 0 1-.48.225Z",
                      fill: "#005BA5",
                    },
                  }),
                ]
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "view_actions" },
            [
              _c("maButton", {
                attrs: {
                  handleButtonClick: _vm.handleCalculateSurface,
                  title: _vm.$t("multidamageList.btnAddAllDamages"),
                  shouldBeDisabled: _vm.mainBtnIsDisabled,
                  btnType: "functionalBtn",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }